import $ from 'jquery';
import { requestPost } from 'src/utils/request';

function newsletterSubmitHandler() {
  $('#email_sub_main').on('submit', function (e) {
    e.preventDefault();
    const form = $(this);
    form.find('input').removeClass('_is-error');

    requestPost(form.attr('action'), form.serialize())
      .then(() => {
        window.location.assign('/welcome-to-our-club#public');
      })
      .catch(() => {
        const error = 'Oops! Something went wrong. Please try again.';
        $('.newsletter__error').empty().html(error).addClass('form-msg-error');
        form.find('input').addClass('_is-error');
      });
  });
}

function initNewsletter() {
  newsletterSubmitHandler();
}

export default {
  init: initNewsletter
};
